import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import VideoDrawer from '@blade-sxp/monitor/components/video-roi-drawer/index.vue';
import SimpleDrawer from '@blade/common/components/paint/simple-drawer.vue';
import { getLablePerson } from '@blade-sxp/monitor/api/monitor-management/task';
import { getRtspPreviewAddress } from '@blade-sxp/monitor/api/device-management/control';
import { debounce } from 'lodash';
let default_1 = class default_1 extends Vue {
    defaultData;
    taskType;
    groupTree;
    deviceDisabled;
    maxDevice;
    size = { width: 500, height: 281 };
    dataSource = [];
    current; //当前正在绘制roi的信息
    selectDevice = {};
    clickDevice = {};
    rtspAddress = '';
    equipmentSelectionNames = [];
    value = '';
    allDrawer1 = [];
    drawButtons = [];
    isOpen = false;
    limits = {};
    isPlayFlag = false;
    directionConfig = {};
    loading = false;
    scrollFun;
    scrollDom;
    MAX_FOCUS_DEVICE = 4;
    // get deviceDisabled() {
    //   const res = this.$route.params.id || Number(this.$route.params.id) === 0;
    //   return !!res;
    // }
    handleOpenDrawer(val, peopleFlag) {
        this.current = {
            id: val.id,
            rtspAddress: val.rtspPreviewAddress,
            allDrawer: peopleFlag ? [...val.allDrawer1] : [...val.allDrawer],
            peopleFlag,
        };
        this.isOpen = true;
        this.directionConfig = {};
        if (peopleFlag) {
            this.drawButtons = ['rect'];
            this.limits = {};
            this.isPlayFlag = true;
        }
        else if (this.taskType === 2) {
            this.drawButtons = ['line', 'lines'];
            this.limits = { total: 1 };
            this.isPlayFlag = false;
            // this.directionConfig = { line: 1,lines: };
        }
        else if (this.taskType === 9) {
            this.drawButtons = ['polygon', 'rect'];
            this.limits = { polygon: 1, rect: 1, total: 1 };
            this.isPlayFlag = false;
            this.directionConfig = { polygon: -1, rect: -1 };
        }
        else if (this.taskType === 10) { //多roi区域统计
            this.drawButtons = ['polygon', 'rect'];
            this.limits = { total: 5 };
            this.isPlayFlag = false;
        }
        else {
            this.drawButtons = ['rect', 'polygon'];
            this.limits = { total: 1 };
            this.isPlayFlag = false;
        }
    }
    handleDrawEnd(data, mode) {
        if (!data)
            return;
        this.isOpen = false;
        const curDrawer = this.dataSource.find((resp) => resp.id === this.current.id);
        if (!curDrawer)
            return;
        if (this.current.peopleFlag) {
            if (data?.length < 3)
                this.$message.warning(this.$t('labWarn').toString());
            curDrawer.allDrawer1 = [...data];
        }
        else {
            if (this.taskType === 5) {
                const arrow = data.filter(item => item.type === 'arrow');
                const polygon = data.filter(item => item.type === 'rect' || item.type === 'polygon');
                if (arrow.length !== 1)
                    this.$message.warning(this.$t('arrowWarn').toString());
                else if (polygon.length > 1)
                    this.$message.warning(this.$t('ploygonWarn').toString());
            }
            else if (this.taskType === 2) {
                curDrawer.modelSelection = mode;
            }
            curDrawer.allDrawer = [...data];
        }
        this.$emit('on-data-chagne', this.dataSource);
    }
    handleNodeClick(node) {
        this.clickDevice = node;
    }
    handleRenderContent(h, { node, data, store }) {
        if (data.level === 0)
            return;
        return (<div class="content-left-item" style="display: flex;flex-direction: row;align-items: center;flex-grow:1;" onDblclick={($e) => this.handleOndbclick($e, data)}>
        {data.nodeType === 'DEVICE' && (<div>
            <img src={require('@blade-sxp/monitor/assets/svgs/rtsp.svg')} class="item-icon" style="width:14px;height:14px;"/>
          </div>)}
        <div class={{ 'text-wrapper': true, 'item-active': data.treeId === Number(this.clickDevice?.id || 0) }}>{data.name} </div>
      </div>);
    }
    async handleOndbclick(event, data) {
        this.$refs.deviceOrganisation.handleClose();
        if (data.nodeType === 'DEVICE') {
            if (this.maxDevice <= this.dataSource.length) {
                this.$message.error(this.$t('maxSelect', [this.maxDevice]).toString());
            }
            else {
                const exists = this.dataSource.findIndex((resp) => Number(resp.id) === data.treeId);
                if (exists === -1) {
                    const initialData = { id: data.treeId, canPlay: data.canPlay, focus: false, name: data.name, rtspPreviewAddress: '', allDrawer: [], allDrawer1: [], };
                    this.dataSource.push(initialData);
                    this.equipmentSelectionNames.push(data.name);
                    this.selectDevice = initialData;
                    if (data.canPlay) {
                        await this.getRtspPreviewAddress(data.treeId); // 获取视频流
                        this.getLablePersons(data.treeId);
                    }
                }
                else {
                    this.$message.error(this.$t('repeatedDevice').toString());
                }
            }
        }
    }
    getLablePersons(deviceId) {
        getLablePerson(deviceId).then(res => {
            const curDrawer = this.dataSource.find((resp) => resp.id === deviceId);
            if (!curDrawer)
                return;
            const drawConfig = JSON.parse(res.data.data || '{}');
            curDrawer.allDrawer1 = drawConfig?.allDrawer1 || [];
            this.$emit('on-data-chagne', this.dataSource);
        }).catch();
    }
    async getRtspPreviewAddress(deviceId, drawerConfig) {
        await getRtspPreviewAddress(deviceId).then(res => {
            if (res.data.code === 0) {
                const curDrawer = this.dataSource.find((resp) => resp.id === deviceId);
                if (!curDrawer)
                    return;
                if (res.data.data.rtspPreviewAddress) {
                    curDrawer.rtspPreviewAddress = res.data.data.rtspPreviewAddress;
                    curDrawer.allDrawer = drawerConfig?.allDrawer || [];
                    this.getLablePersons(deviceId);
                    curDrawer.canPlay = true;
                }
            }
            else
                this.$message.error(res.data.message || this.$t('deviceLoadError').toString());
        })
            .catch(() => {
            this.$message.error(this.$t('deviceLoadError').toString());
        });
    }
    /**
     *@Description: 设备选择移除
     *@Date: 2020-09-16 17:54:45
     */
    removeTag(e) {
        const eqIndex = this.dataSource.findIndex((item) => item.id === e);
        if (eqIndex !== -1) {
            this.dataSource.splice(eqIndex, 1);
            this.equipmentSelectionNames.splice(eqIndex, 1);
        }
    }
    removeTagByName(name) {
        const eqIndex = this.dataSource.findIndex((item) => item.name === name);
        if (eqIndex !== -1) {
            this.dataSource.splice(eqIndex, 1);
        }
    }
    onDataSourceChange(newVal) {
        this.scrollFun?.();
        // this.setPlayersFocus(); 
    }
    selectChange(e) {
    }
    onDefaultDataChange() {
        this.init();
    }
    onGroupTreeChange() {
        // this.init();
    }
    async mounted() {
        await this.init();
        this.initEventListener();
    }
    async init() {
        this.dataSource = [];
        this.equipmentSelectionNames = [];
        for (const detail of this.defaultData) {
            const data = {
                id: detail.deviceId,
                name: detail.deviceName,
                rtspPreviewAddress: '',
                allDrawer: [],
                allDrawer1: [],
                canPlay: false,
                focus: false,
                modelSelection: JSON.parse(detail?.configJson || '{}')?.modelSelection,
            };
            this.equipmentSelectionNames.push(detail.deviceName);
            this.dataSource.push(data);
            const drawConfig = JSON.parse(detail?.frontEndData || '{}');
            await this.getRtspPreviewAddress(detail.deviceId, drawConfig);
        }
    }
    initEventListener() {
        this.scrollFun = debounce(this.setPlayersFocus, 500);
        this.scrollDom = document.body.querySelector('.main-scroll-view');
        this.scrollDom.addEventListener('scroll', this.scrollFun);
    }
    beforeDestroy() {
        this.scrollDom.removeEventListener('scroll', this.scrollFun);
    }
    setPlayersFocus() {
        const targetDom = this.$refs.imgs;
        if (!targetDom)
            return;
        const domList = targetDom.children;
        let focused = 0;
        const height = window.innerHeight || document.documentElement.clientHeight;
        const minTop = 100;
        for (let i = 0, len = this.dataSource.length; i < len; i++) {
            const device = this.dataSource[i];
            device.focus = false;
            if (focused >= this.MAX_FOCUS_DEVICE)
                continue;
            const item = domList[i];
            if (item) {
                const rect = item.getBoundingClientRect();
                if (rect.bottom >= minTop && rect.top >= minTop && rect.bottom <= height && rect.top <= height) {
                    device.focus = true;
                    focused += 1;
                }
                //console.log(8888884,rect.top,rect.bottom,height,device.focus);
            }
        }
    }
};
__decorate([
    Prop({ default: () => [] })
], default_1.prototype, "defaultData", void 0);
__decorate([
    Prop({ default: -1 })
], default_1.prototype, "taskType", void 0);
__decorate([
    Prop({ default: () => [] })
], default_1.prototype, "groupTree", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "deviceDisabled", void 0);
__decorate([
    Prop({ default: Number.MAX_SAFE_INTEGER })
], default_1.prototype, "maxDevice", void 0);
__decorate([
    Watch('dataSource')
], default_1.prototype, "onDataSourceChange", null);
__decorate([
    Watch('defaultData')
], default_1.prototype, "onDefaultDataChange", null);
__decorate([
    Watch('groupTree')
], default_1.prototype, "onGroupTreeChange", null);
default_1 = __decorate([
    Component({
        name: 'CreateTask',
        components: {
            VideoDrawer,
            SimpleDrawer,
        },
        i18n: {
            messages: {
                'en-us': {
                    fail: 'create Fail',
                    region: 'Area Drawing',
                    crossLine: 'Cross Line Drawing',
                    body: 'Body Tag',
                    deviceLoadError: 'Device Load Error',
                    labWarn: 'at least draw 3 items',
                    arrowWarn: 'need draw one arrow line',
                    ploygonWarn: 'only one polygon needed',
                    integerRangeError: 'Please Input Integer Of {0}~{1}',
                    numberRangeError: 'Please Input Number Of {0}~{1}',
                    onlySupports: 'Currently only supports adding one device',
                    maxSelect: 'Support up to {0} devices',
                    repeatedDevice: 'Repeat Selection Device',
                },
                zh: {
                    region: '区域绘制',
                    crossLine: '跨线绘制',
                    fail: '创建失败',
                    body: '手动人体标定',
                    deviceLoadError: '设备加载异常',
                    labWarn: '至少需要绘制3个图形',
                    arrowWarn: '需要绘制一个方向',
                    ploygonWarn: '最多绘制一个多边形',
                    integerRangeError: '请填写{0}~{1}的整数',
                    numberRangeError: '请填写{0}~{1}的数字',
                    onlySupports: '目前只支持添加一个设备',
                    maxSelect: '目前只支持添加{0}个设备',
                    repeatedDevice: '重复选择设备',
                },
            },
        },
    })
], default_1);
export default default_1;
